define(['app/control/uploader', 'app/modules/university', 'app/modules/map', 'app/modules/shorten', 'scriptjs'],
    function(Uploader, University, googleMap, Shorten, $script) {
      var Universities = function () {};

      Universities.prototype.actionShow = function(){
        var student_resources = $('.student-resources');

        $('.shorten').not('.shorten-init').each(function(){
          Shorten.init($(this));
        });

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
          $('.shorten').not('.shorten-init').each(function(){
            Shorten.init($(this));
          });
        });

        $script.ready('google-maps',function() {
          var locations_tabs_wrapper = $('.university-locations-tabs');
          var locations_tabs = locations_tabs_wrapper.find('.nav-tabs a[data-toggle=tab]');
          var active_location = locations_tabs_wrapper.find('.locations-tabs .nav-tabs .active a[role=tab]');
          var mapMarkers = {};

          var mapCanvas = document.getElementById('university_map');

          if(mapCanvas){
            var lat = $(active_location).attr('data-lat');
            var lon = $(active_location).attr('data-lon');
            googleMap.init(mapCanvas, { zoom: 12, lat: lat, lon: lon }).then(map => {
              $.each(locations_tabs_wrapper.find('.locations-tabs .nav-tabs li'), function(){
                var location = $(this).find('a[role=tab]');

                mapMarkers['location_'+$(location).attr('data-id')] = googleMap.addMarker(map, {
                  lat: $(location).attr('data-lat'),
                  lon: $(location).attr('data-lon')
                })
              });

              locations_tabs.on('shown.bs.tab', function(){
                googleMap.clearMarkers(mapMarkers);
                googleMap.showMarker(map, mapMarkers['location_'+$(this).attr('data-id')]);
              });
            });
          }
        });

        student_resources.find('input.resource-filter-input').iCheck({ handle: 'checkbox' }).on('ifChecked', function(){
          $(this).parents('.resource-filter-item').addClass('active');
        }).on('ifUnchecked', function(){
          $(this).parents('.resource-filter-item').removeClass('active');
        }).on('ifChanged', function(){
          clearTimeout(window.filter_timeout);
          window.filter_timeout = setTimeout(function(){
            University.filterResources();
          }, 1000);
        });

        student_resources.find('.get-student-resource').on('click', function(e){
          University.getResource(e);
        });
      };

      Universities.prototype.actionEdit = Universities.prototype.actionUpdate = function(){
        var uplCoverPicture = new Uploader($('#university_cover_picture_uploader'), {
          type: 'image',
          autoUpload: true,
          field_name: 'Cover Picture'
        });
        var uplLogo = new Uploader($('#university_logo_uploader'), {
          type: 'image',
          autoUpload: true,
          field_name: 'Logo'
        });
        var uplDescImage = new Uploader($('#university_desc_image_uploader'), {
          type: 'image',
          autoUpload: true,
          field_name: 'Photo'
        });

        $('input#university_color').minicolors();

        $('form.university-form').on('nested:fieldAdded', function(e){
          $(e.field).find('.chosen-select-with-search').chosen({
            disable_search_threshold: 10,
            width: "100%",
            allow_single_deselect: true
          });
        });
      };

      Universities.prototype.actionJb_edit = Universities.prototype.actionJb_update = function(){
        var jb_form = $('.universities form.university-job-board-form');

        jb_form.find('#board_jb_type').on('change', function(){
          jb_form.find('.job-board-type').addClass('hidden');
          jb_form.find('.job-board-type[data-type='+$(this).val()+']').removeClass('hidden');
        });

        jb_form.find('.jb-test-url').on('click', function(e){
          var url = $(this).parent().find('input.jb-url').val();

          if(url){
            $(this).attr('href', url);
          } else {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      };

      Universities.prototype.actionMember_edit = function(){
        var domain_form = $('form.university-student-domains-form');
        var invite_form = $('form.invite-form');

        domain_form.on('submit', function(e){
          e.preventDefault();
          e.stopPropagation();

          University.addDomain($(this));
        });

        domain_form.on('click', '.allowed-domains .remove-domain', function(e){
          e.preventDefault();
          e.stopPropagation();

          University.deleteDomain($(this));
        });

        invite_form.on('submit', function(e){
          e.preventDefault();
          e.stopPropagation();

          University.inviteMember($(this));
        });
      };

      Universities.prototype.actionCv_books_edit = function(){
        var cv_book_form = $('.modal-cv-book form.university-cv-book-form');

        cv_book_form.on('submit', function(e){
          e.preventDefault();
          e.stopPropagation();

          University.addCvBook($(this));
        });
      };

      return Universities;
});
